import type { ISupportDiagnosticsApp } from '@srm/screen-sharing/light';
import type { IActiveSubstitution } from '@molecules/SubstitutionBanner/substitution';

let current: ISupportDiagnosticsApp['substitution'] | undefined;

/**
 * Замещение пользователя для пакета диагностики (§43.2): баннер замещения уже спрашивает его у сервера (`getAssistant`),
 * пакет берёт готовое и отдельного запроса не делает. Запланированное — ещё не замещение.
 */
export function publishSupportSubstitution(substitution: IActiveSubstitution | null): void {
    if (!substitution || substitution.scheduled) {
        current = undefined;
        return;
    }
    const end = substitution.endDate;
    const endDate = end instanceof Date ? end.toISOString() : end || undefined;
    current = { name: substitution.name, kind: substitution.kind, ...(endDate ? { endDate } : {}) };
}

export const supportSubstitution = () => current;
